import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';

export default class NodeGroupObjects extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addOutput(PARAM_TYPE.SPLINE, 'geo');
	}

	getType()
	{
		return 'groupObjects';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pRes = [];
		let pInputs = this.getInputs();
		for(let pInput of pInputs)
		{
			if(!pInput.getConnectedNode())
				continue;

			const strName = pInput.getName();
			if(Array.isArray(inputValues[strName]))
				pRes = pRes.concat(inputValues[strName]);
			else if(inputValues[strName] !== null)
				pRes.push(inputValues[strName]);
		}

		let pDummyParentMesh = new BABYLON.Mesh(this.getGeneratedMeshName(), scene);		
		this.onMeshCreated(pDummyParentMesh);

		for(let pSrcMesh of pRes)
		{
			if(!pSrcMesh)
				continue;

			if(pDummyParentMesh.parentGraphId !== pSrcMesh.parentGraphId)
				console.error('Parenting objects between two different graphs!');

			pSrcMesh.parent = pDummyParentMesh;
		}

		return [pDummyParentMesh];
	}
}